import React, { useEffect, useRef, useState, ChangeEvent } from "react";
import "./home.scss";
import Paragraph from "../components/atoms/paragraph/paragraph";
import Banner from "../components/molecules/banner/banner";
import Body from "../components/organisms/body/body";
import image from "../assets/images/logo_mass.png";
import Input from "../components/atoms/input/input";
import axios from "axios";
import { resolver } from "../util/objectUtilities";
import { createHash } from "crypto";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const Contenedor = styled.div`
  display: flex;
  flex-direction: column; /* Asegura que los elementos se apilen en móviles */
  align-items: center;
  width: 80%;
  max-width: 1200px;
  margin-left: 20px; /* Ajusta el margen izquierdo */
  margin-right: auto;
  padding: 10px;

  @media (max-width: 768px) {
    width: 95%;
  }
`;

function Home() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const origen = queryParams.get("origen") || "MAAS_APP";
  const servicio = queryParams.get("servicio");
  const saveableCanvas = useRef();
  const textBody = useRef();
  const [preguntasXTipo, setPreguntasxTipo] = useState();
  const [preguntasAll, setPreguntas] = useState();
  const [message, setMessage] = useState("");
  const [message2, setMessage2] = useState("");
  const [numeroTarjeta, setNumTarjeta] = useState("");
  const [celular, setCelular] = useState("");
  const [celularnuevo, setCelularNuevo] = useState("");
  const [numeroDoc, setNumeroDoc] = useState("");
  const [tipoIdDocumento, setTipoIdDocumento] = useState("");
  const [label_archivo, setLabelArchivo] = useState("");
  const [error, setError] = useState(false);
  const [state, setState] = useState();
  const [fields, setFields] = useState([]);
  const [formValues, setFormValues] = useState({
    tipoUsuario: "",
    nombre: "",
    apellido: "",
    tipoDoc: "",
    numeroDoc: "",
    tipoIdDocumento:"",
    tipoDocIdTexto:"",
    idContactoCRM:"",
    idAsignadoContactoCRM:"",
    email: "",
    celular: "",
    numeroTarjeta:"",
    fechaNacimiento:"",
    tipoPQR:"",
    preguntas:"",
    archivos_visible :false,
    soloLectura:false,
    soloLectura_Encabezado:false,
    visualizar_campos :false,
    visualizar_saludo: false,
    visualizar_fecha_nacimiento:false,
    visualizar_existente:false,
    visualizar_nuevo:false,
    contacto_nuevo:false,
    campos_adicionales:false,
    fechaHoraCompra:"",
    fechayhoradelevento:"",
    valorCompra:"",
    codigoCUS:"",
    versionApp:"",
    userid:"",
    correonuevo:"",
    celularnuevo:"",
    nombreempresaaliado:"",
    plataformadepago:"",
    funcionalidad:"",
    archivo1:"",
    habeasdata_visible:false,
    boton_visible :false,
    boton_siguiente_visible :true,
    asunto:"",
    descripcion:"",
    servicio: "",
    mostrarIdentificacion: false,
    servicioBloqueado: false,
    ubicacionorigen:"",
    ubicacion:"",
    descripcion_visible:false,
    notificacion:"",
    tiempo_respuesta:""
    //identificacionServicio:"",
    //configIdentificacion:""
  });

  const SERVICIOS_VALIDOS = ["CABIFY", "SITP BOGOTA", "PARKING", "TULLAVE"];

  /*useEffect(() => {
  const params = new URLSearchParams(location.search);
  const servicioURL = params.get("servicio");

  if (servicioURL) {
    // Guardar servicio en el formulario
    handleInput("servicio", servicioURL);
    handleInput("mostrarIdentificacion", true);
    handleInput("servicioBloqueado", true); 
  }
}, [location.search]);*/

useEffect(() => {
  const params = new URLSearchParams(location.search);
  var servicioURL = params.get("servicio");

  const SERVICIOS_VALIDOS = ["TAXI", "SITP BOGOTA", "PARKING", "TULLAVE"];

  if (servicioURL && SERVICIOS_VALIDOS.includes(servicioURL)) {
    // Servicio válido → bloquear y continuar flujo normal
    if (servicioURL=="SITP BOGOTA"){
        servicioURL="TULLAVE";
    }
    handleInput("servicio", servicioURL);
    handleInput("mostrarIdentificacion", true);
    handleInput("servicioBloqueado", true);
  } else {
    // Servicio inválido o vacío → mostrar select
    handleInput("servicio", "");
    handleInput("mostrarIdentificacion", false);
    handleInput("servicioBloqueado", false);
  }
}, [location.search]);

  const config = formValues.identificacionServicio?.[formValues.servicio];

  const recaptchaRef = useRef();
  const [aceptado, setAceptado] = useState(false);

  const handleChange = (e) => {
    setAceptado(e.target.checked);
    if (!aceptado){
      handleInput("boton_visible",true);
    }else{
      handleInput("boton_visible",false);
    }

  };

  function KeyPress(event) {
    if (event.ctrlKey && event.key === "z") {
      saveableCanvas.current.undo();
    }
  }

  if (typeof document !== "undefined") {
    document.addEventListener("keydown", KeyPress);
  }

  function handleInput(name, value) {
    name &&
      setFormValues((s) => {
        return {
          ...s,
          [name]: value,
        };
      });
  }

  function validarEdad () {
    let edadNoCumple = false;
    try {
      console.log ('Entro: ' + formValues.fechaNacimiento);
      const fechaSeleccionada = new Date(formValues.fechaNacimiento);
      const hoy = new Date();
      
      // Calcula la edad
      const edad = hoy.getFullYear() - fechaSeleccionada.getFullYear();
      console.log ('edad: ' + edad);
      // Ajuste si el cumpleaños aún no ha pasado este año
      const cumpleEsteAnio =
        hoy.getMonth() > fechaSeleccionada.getMonth() ||
        (hoy.getMonth() === fechaSeleccionada.getMonth() && hoy.getDate() >= fechaSeleccionada.getDate());
    
      const edadFinal = cumpleEsteAnio ? edad : edad - 1;
      console.log ('edadFinal: ' + edadFinal);
      // Si es menor de 7 años, muestra un mensaje de error
      if (edadFinal < 7) {
        edadNoCumple = true;
      }
      console.log ('edadNoCumple: ' + edadNoCumple);
    } catch (e) {
      setError(true);
      setMessage2("Se genero un error en el proceso. Intentenlo nuevamente... ");
      console.error(e);
      if (typeof e.response !== "undefined") {
        console.error(e.response.data);
      }
      
    }
    return edadNoCumple;
  };

  async function handleSubmit() {
    try {
        setError(false);
        let blnValidacionesOK = true;
        let strError = '';
        const regex = /^[a-zA-Z\s]*$/; // Solo letras y espacios
        /*if (formValues.numeroTarjeta.length<16){        
          strError =  strError + "La tarjeta debe tener 16 digitos" + "\n";
          blnValidacionesOK =false;
        }*/

        if (config) {
          const longitudEsperada = config.longitud;
          const labelCampo = config.label;

          // Validar solo si el campo es obligatorio
          if (config.obligatorio) {
            if (formValues.numeroTarjeta.length < longitudEsperada) {
              strError += `${labelCampo} debe tener ${longitudEsperada} caracteres\n`;
              blnValidacionesOK = false;
            }
          }
        }

        // validaciones para el caso en que el contacto es nuevo
        if (formValues.idContactoCRM ==''){
          if (formValues.email.length>255){        
            strError =  strError + "El correo electronico no puede tener mas de 255 caracteres" + "\n";
            blnValidacionesOK =false;
          }
  
          if (formValues.numeroDoc.length<5){        
            strError =  strError + "El numero de documento debe tener entre 5 y 16 digitos" + "\n";
            blnValidacionesOK =false;
          }
  
          if (formValues.celular.length<10){        
            strError =  strError + "El numero de celular debe tener 10 digitos" + "\n";
            blnValidacionesOK =false;
          }
  
          if (formValues.nombre.length>100){        
            strError =  strError + "El nombre no puede tener mas de 100 letras" + "\n";
            blnValidacionesOK =false;
          }
  
          if (!regex.test(formValues.nombre)) {
            strError =  strError + "El nombre solo puede tener letras o espacios" + "\n";
            blnValidacionesOK =false;
          }

          if (formValues.nombre.trim()==="") {
            strError =  strError + "El nombre no puede estar vacío o solo contener espacios\n";
            blnValidacionesOK =false;
          }
  
          if (!regex.test(formValues.apellido)) {
            strError =  strError + "El apellido solo puede tener letras o espacios" + "\n";
            blnValidacionesOK =false;
          }
  
          if (formValues.apellido.trim()==="") {
            strError =  strError + "El apellido no puede estar vacío o solo contener espacios\n";
            blnValidacionesOK =false;
          }

          if (formValues.apellido.length>100){        
            strError =  strError + "El apellido no puede tener mas de 100 letras" + "\n";
            blnValidacionesOK =false;
          }
        }
      
        if (formValues.visualizar_fecha_nacimiento && formValues.fechaNacimiento!= '' && validarEdad()){
          strError =  strError + "Edad no permitda" + "\n";
          blnValidacionesOK =false;
        }

        if (formValues.correonuevo != ""){
          if (formValues.correonuevo.length>255){        
            strError =  strError + "El correo electronico nuevo no puede tener mas de 255 caracteres" + "\n";
            blnValidacionesOK =false;
          }
          const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!regex.test(formValues.correonuevo)){
            strError =  strError + "Por favor ingrese un correo nuevo válido." + "\n";
            blnValidacionesOK =false;
          }
 
        }
        if (formValues.celularnuevo != ""){
          if (formValues.celularnuevo.length<10){        
            strError =  strError + "El numero de celular nuevo debe tener 10 digitos" + "\n";
            blnValidacionesOK =false;
          }
        }
        let strValorCompra ='';
        if (formValues.valorCompra != ""){
          strValorCompra =  formValues.valorCompra.replace(/[.,]/g, ""); // Elimina ambos . y , caracteres
           let valorNumerico = parseInt(strValorCompra, 10); // Convierte el string a número entero
           //2026-04-09-pvahos: Se quita esta validacion por solicitud del cliente 
           //if (valorNumerico < 10000) {
              //  strError =  strError + "El valor de la compra debe ser mayor o igual a COP $10.000 (Diez mil pesos colombianos)" + "\n";
                //blnValidacionesOK =false;
            //}
        }
        

        if (blnValidacionesOK){
          setMessage ("");
          setMessage2("Espere un momento mientras se genera su numero de caso...Puede tardar unos segundos...");
          handleInput("boton_visible",false);
          handleInput("habeasdata_visible",false);
          handleInput("boton_siguiente_visible",false);
   
          let strBase64 = ''; 
          let strFileName = '';   
          let strFileType = '';     
          
          if (state == null){
            console.log("Archivo 1 Esta vacio");
          }else{
            let reader = new FileReader()
            reader.readAsDataURL(state.selectedFile)
            await new Promise(resolve => reader.onload = () => resolve());
            strBase64 = reader.result.split(',')[1];
            strFileName = state.selectedFile.name;
            strFileType = state.selectedFile.type;
            //console.log("strBase64: ", strBase64);
          }
          var dtFechaHoraCompra = "";
          if (formValues.fechaHoraCompra!= "" && formValues.fechaHoraCompra!= null){
            dtFechaHoraCompra= formValues.fechaHoraCompra.replace("T", " ");
          }
          var dtFechayhoradelevento = "";
          if (formValues.fechayhoradelevento!= "" && formValues.fechayhoradelevento!= null){
            dtFechayhoradelevento= formValues.fechayhoradelevento.replace("T", " ");
          }
          var servicio_local = formValues.servicio;
          if (servicio_local=="SITP BOGOTA"){
              servicio_local="TULLAVE";
          }
          const newPost = {
            str_Base64:strBase64,
            str_FileName: strFileName,
            str_FileType: strFileType,
            str_Nombre:formValues.nombre,
            str_Apellido: formValues.apellido,
            str_Cedula:formValues.numeroDoc,
            str_FechaNacimiento: formValues.fechaNacimiento,
            str_Tarjeta:formValues.numeroTarjeta,
            str_IDContacto: formValues.idContactoCRM, 
            str_IDAsignadoContacto: formValues.idAsignadoContactoCRM,       
            str_TipoDoc: formValues.tipoIdDocumento,
            strInfoPregunta: formValues.preguntas,
            str_Descripcion: formValues.descripcion,
            str_Celular:formValues.celular,       
            str_Correo:formValues.email,
            str_Plataforma:origen,
            str_cases_fechayhoradelacompra:dtFechaHoraCompra,
            str_cases_valordelacompra:strValorCompra,
            str_cases_codigocus:formValues.codigoCUS,
            str_cases_versiondelaapp:formValues.versionApp,
            str_cases_userid:formValues.userid,
            str_cases_correonuevo:formValues.correonuevo,
            str_cases_celularnuevo:formValues.celularnuevo,
            str_cases_nombreempresaaliado:formValues.nombreempresaaliado,
            str_cases_plataformadepago:formValues.plataformadepago,
            str_cases_funcionalidad:formValues.funcionalidad,
            str_cases_servicio:servicio_local,
            str_cases_fechayhoradelevento:dtFechayhoradelevento,
            str_cases_ubicacionorigen:formValues.ubicacionorigen,
            str_cases_ubicacion:formValues.ubicacion              
           };
  
           console.log("newPost: ", newPost);
           const resp = await axios.post('https://sys.conexo.com.co/Conexo_WS/serviciosCRM/ConexoCRM/createCasoMass', newPost, {auth: {
           //const resp = await axios.post('https://sys.conexo.com.co/Conexo_WS_QA/serviciosCRM/ConexoCRM/createCasoMass', newPost, {auth: {
           username: 'mass_user',
            password: 'M455_2025*'}
          });
         
          console.log("resp: ", resp);
          if (resp.data.str_ErrorCode === '0') {
            const PREFIJO_CASO_EXISTENTE = "ComentarioCreado_CasoExistente|";
            const respuestaCaso = resp.data.str_NumeroCaso || "";
            const tiempoRespuesta = (formValues.tiempo_respuesta || "").trim();

            if (respuestaCaso.startsWith(PREFIJO_CASO_EXISTENTE)) {
              const numeroCaso = respuestaCaso.substring(PREFIJO_CASO_EXISTENTE.length);
              setMessage2(
                `¡Listo! Ya tenías el caso ${numeroCaso} creado previamente. Acabamos de actualizarlo con tu nuevo comentario para nuestros asesores.`
              );
            } else if (tiempoRespuesta) {
              setMessage2(
                `¡Listo! Tu reclamación quedó registrada con el número ${respuestaCaso}, te enviaremos la respuesta a tu correo en un plazo de hasta ${tiempoRespuesta}.`
              );
            } else {
              setMessage2(
                `¡Listo! Tu consulta quedó registrada en el caso informativo ${respuestaCaso}. La respuesta a tu pregunta frecuente ya fue enviada a tu correo registrado. Revísalo para encontrar todos los detalles.`
              );
            }
          } else {
            setError(true);
            setMessage2(resp.data.str_ErrorMessage);
            //alert(resp.data.str_ErrorMessage);
          }
          } else {
            setError(true);
            setMessage(strError);
          }
        
      
    } catch (e) {
      setError(true);
      setMessage2("Se genero un error en el proceso. Intentenlo nuevamente... ");
      console.error(e);
      if (typeof e.response !== "undefined") {
        console.error(e.response.data);
      }
      
    }
  }  


async function nextButton() {
  try {
    const strNumDoc = formValues.numeroDoc;
    const strEmail = formValues.email;

    // ============================
    // Validaciones básicas
    // ============================
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!strNumDoc || !strEmail) {
      setMessage2("Debe ingresar número de documento y correo electrónico");
      return;
    }

    if (!regex.test(strEmail)) {
      setMessage2("Por favor ingrese un correo válido.");
      return;
    }

    setMessage2("");

    // ============================
    // Construir Basic Auth
    // ============================
    const basicAuth = "Basic " + btoa("maas_user:M455_2025*");

    // ============================
    // Llamar al backend validateContact
    // ============================
    const resp = await axios.post(
      "https://sys.conexo.com.co/Conexo_WS/serviciosCRM/ConexoCRM/validateContact",
      //"http://localhost:8080/Conexo_WS_QA/serviciosCRM/ConexoCRM/validateContact",
      {
        documento: strNumDoc,
        email: strEmail
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": basicAuth
        }
      }
    );

    const data = resp.data;

    // ============================
    // Manejo de respuestas
    // ============================
    switch (data.status) {

      case "vtiger":
        handleInput("visualizar_campos", false);
        handleInput("visualizar_existente", true);
        handleInput("visualizar_nuevo", false);
        handleInput("soloLectura", true);
        handleInput("soloLectura_Encabezado", true);
        handleInput("boton_siguiente_visible", false);
        handleInput("visualizar_saludo", true);

        handleInput("idContactoCRM", data.contacto.id);
        handleInput("idAsignadoContactoCRM", data.contacto.assigned_user_id);
        handleInput("nombre", data.contacto.firstname);
        handleInput("apellido", data.contacto.lastname);
        handleInput("celular", data.contacto.mobile);

        if (!data.contacto.birthday) {
          handleInput("visualizar_fecha_nacimiento", true);
        } else {
          handleInput("visualizar_fecha_nacimiento", false);
        }
        break;

      case "bd_propia":
        handleInput("visualizar_campos", false);
        handleInput("visualizar_existente", true);
        handleInput("visualizar_nuevo", false);
        handleInput("soloLectura", true);
        handleInput("soloLectura_Encabezado", true);
        handleInput("boton_siguiente_visible", false);
        handleInput("visualizar_saludo", true);

        handleInput("idContactoCRM", "CONTACTO_BDPROPIA_MAAS");
        handleInput("nombre", data.contacto.nombre);
        handleInput("apellido", data.contacto.apellido);
        handleInput("tipoIdDocumento", data.contacto.tipo_documento);
        handleInput("celular", data.contacto.celular);

        if (!data.contacto.fecha_nacimiento) {
          handleInput("visualizar_fecha_nacimiento", true);
        } else {
          handleInput("fechaNacimiento", data.contacto.fecha_nacimiento);
          handleInput("visualizar_fecha_nacimiento", false);
        }
        break;

      case "email_no_match":
        setMessage2("Este correo no está registrado para la cédula ingresada.");
        handleInput("visualizar_campos", false);
        break;

      case "nuevo":
        handleInput("idContactoCRM", "");
        handleInput("idAsignadoContactoCRM", "");
        handleInput("visualizar_existente", false);
        handleInput("visualizar_nuevo", true);
        handleInput("visualizar_campos", true);
        handleInput("soloLectura", false);
        handleInput("soloLectura_Encabezado", true);
        handleInput("boton_siguiente_visible", false);
        handleInput("visualizar_saludo", true);
        handleInput("contacto_nuevo", true);
        handleInput("visualizar_fecha_nacimiento", true);
        break;

      default:
        setMessage2("Error inesperado validando contacto.");
        break;
    }
    const servicio = formValues.servicio;
    cargarPreguntas(servicio);


  } catch (e) {
    setError(true);
    console.error(e);
    setMessage2("En este momento nuestro canal de atención está saturado, espera un par de minutos y vuelve a intentar. Agradecemos tu comprensión");

    if (e.response) {
      console.error("Error en la solicitud:", e.response.status);
      console.error("Descripción del error:", e.response.data);
      createLogError("ERR_RESP_SRV","validateContact - Error de respuesta del servidor (código diferente a 2xx): " + e.response.status + " - " + JSON.stringify(e.response.data)
      );

    } else if (e.request) {
      console.error("No hubo respuesta del servidor:", e + JSON.stringify(e.request, null, 2));
      createLogError("ERR_NO_RESP_SRV","validateContact - No hubo respuesta del servidor: " + e +JSON.stringify(e.request, null, 2)
      );

    } else {
      console.error("Error general en la solicitud:", e.message);
      createLogError( "ERR_OTHER","validateContact - Otro tipo de error (configuración, red, etc.): " + e.message
      );
    }
  }
}
 
async function cargarPreguntas(servicio_consulta) {
  try {
    const basicAuth = "Basic " + btoa("maas_user:M455_2025*");
    const ordenNotificacion = "0";
    const resp = await axios.post(
      "https://sys.conexo.com.co/Conexo_WS/serviciosCRM/ConexoCRM/getPreguntas",
      //"https://sys.conexo.com.co/Conexo_WS_QA/serviciosCRM/ConexoCRM/getPreguntas",
      { servicio: servicio_consulta },
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": basicAuth
        }
      }
    );

    if (resp.data.status === "ok") {
      const todasLasPreguntas = resp.data.preguntas || [];

      // 1. Buscar la notificacion previa
      const notificacionPrevia = todasLasPreguntas.find(
        p => String(p.cf_vtcmasignacionescaso_orden).trim() === ordenNotificacion
      );

      // 2. Capturar su nombre (queda en null si no viene en la respuesta)
      const texto_informativo = notificacionPrevia
        ? notificacionPrevia.fld_vtcmasignacionescasoname
        : null;
           
      handleInput("notificacion", texto_informativo || "");

      // 3. Quitar la notificacion del arreglo
      const preguntasFiltradas = todasLasPreguntas.filter(
        p => String(p.cf_vtcmasignacionescaso_orden).trim() !== ordenNotificacion
      );

      setPreguntas(preguntasFiltradas);

      // Identificación de servicio (se toma de la primera pregunta disponible)
      if (todasLasPreguntas.length > 0) {
        const identificacionServicio = parseIdentificacionServicio(
          todasLasPreguntas[0].cf_vtcmasignacionescaso_identificacionservicio
        );

        setFormValues(s => ({
          ...s,
          identificacionServicio
        }));
      }
    }

  } catch (e) {
    setError(true);
    console.error(e);
    setMessage2("En este momento nuestro canal de atención está saturado, espera un par de minutos y vuelve a intentar. Agradecemos tu comprensión");

    if (e.response) {
      createLogError("ERR_RESP_SRV", "getPreguntas - " + e.response.status);
    } else if (e.request) {
      createLogError("ERR_NO_RESP_SRV", "getPreguntas - sin respuesta");
    } else {
      createLogError("ERR_OTHER", "getPreguntas - " + e.message);
    }
  }
}

async function cargarPreguntas_old(servicio_consulta) {
  try {
    const basicAuth = "Basic " + btoa("maas_user:M455_2025*");

    const resp = await axios.post(
      "https://sys.conexo.com.co/Conexo_WS/serviciosCRM/ConexoCRM/getPreguntas",
      //"https://sys.conexo.com.co/Conexo_WS_QA/serviciosCRM/ConexoCRM/getPreguntas",
      { servicio: servicio_consulta },
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": basicAuth
        }
      }
    );

    if (resp.data.status === "ok") {
      setPreguntas(resp.data.preguntas);
      const identificacionServicio = parseIdentificacionServicio(
        resp.data.preguntas[0].cf_vtcmasignacionescaso_identificacionservicio
      );

      setFormValues(s => ({
        ...s,
        identificacionServicio
      }));
    }

  } catch (e) {
    setError(true);
    console.error(e);
    setMessage2("En este momento nuestro canal de atención está saturado, espera un par de minutos y vuelve a intentar. Agradecemos tu comprensión");

    if (e.response) {
      createLogError("ERR_RESP_SRV", "getPreguntas - " + e.response.status);
    } else if (e.request) {
      createLogError("ERR_NO_RESP_SRV", "getPreguntas - sin respuesta");
    } else {
      createLogError("ERR_OTHER", "getPreguntas - " + e.message);
    }
  }
}

function parseIdentificacionServicio(str) {
  const result = {};

  if (!str) return result;

  const bloques = str.split("|##|");

  bloques.forEach(b => {
    const partes = b.split("|").map(x => x.trim());

    if (partes.length >= 5) {
      const servicio = partes[0];
      const obligatorio = partes[1] === "M";
      const label = partes[2];
      const tipo = partes[3];       // "text" o "number"
      const longitud = parseInt(partes[4], 10);

      result[servicio] = {
        obligatorio,
        label,
        tipo,
        longitud
      };
    }
  });

  return result;
}

  

  async function createLogError(strErrorCode, strErrorMessage) {
          const newPost = {
                    contact_id:"4x890754",
                    title: "ERROR_MAAS_CREAR_CASO",
                    description: strErrorCode + " - " + strErrorMessage                                     
                  };
  
           
           const resp = await axios.post('https://conexo2.od1.vtiger.com/restapi/vtap/webhook/createLogError', newPost, 
             {
                headers: {
                  'token': 'BMmHtab702vgJ4bqGYrgw7LU',
                  'Content-Type': 'application/json'
                }
              });
  }

  async function  getPreguntas(strTipoPQRS){
    const preguntasXTipoPQRS =[];
    // Store results in the results array
    preguntasAll.forEach((value) => {
      if (strTipoPQRS==value.fld_tipopqr_2311){
        preguntasXTipoPQRS.push({
        value: value.id,
        label: value.fld_vtcmasignacionescasoname,
        });
      }
      
    });
    //console.log("results", results); preguntasXTipo, setPreguntasxTipo
    // Update the options state
    setPreguntasxTipo([ 
      ...preguntasXTipoPQRS
    ])

  }

  async function  validatePreguntaInfo(strIdPregunta){
    
    //Limpiar campos
    handleInput("codigoCUS","");
    handleInput("versionApp","");
    handleInput("userid","");
    handleInput("correonuevo","");
    handleInput("celularnuevo","");
    handleInput("nombreempresaaliado","");
    handleInput("plataformadepago","");
    handleInput("funcionalidad","");
    handleInput("fechaHoraCompra","");
    handleInput("fechayhoradelevento","");
    handleInput("valorCompra","");
    handleInput("ubicacionorigen","");
    handleInput("ubicacion","");
    // Store results in the results array
    preguntasAll.forEach((value) => {
      if (strIdPregunta==value.id){
        const strRequiereDoc = value.cf_vtcmasignacionescaso_documentoobligatorio;
        const strTextoDoc = value.cf_vtcmasignacionescaso_textotipodocumento;
        const strCamposDinamicos = value.cf_vtcmasignacionescaso_camposdinamicos;
        const strSolicitarDescripcion = value.cf_vtcmasignacionescaso_solicitardescripcion;
        const strTiempoRespuesta = (value.cf_vtcmasignacionescaso_tiemporespuestaacliente || "").trim();
        console.log("strTiempoRespuesta", strTiempoRespuesta);
        handleInput("tiempo_respuesta",strTiempoRespuesta);


        if (strSolicitarDescripcion == 'NO'){
            handleInput("descripcion_visible",false);
            handleInput("descripcion","**SIN DESCRIPCION**");
        }else{
          handleInput("descripcion_visible",true);
        }
        handleInput("habeasdata_visible",true);
        setMessage2("");
        if (strRequiereDoc=='SI'){
          handleInput("archivos_visible",true);
          setLabelArchivo(strTextoDoc);
          
        }else{
          handleInput("archivos_visible",false);
        }
        var array = [];
        if (strCamposDinamicos!= "" && strCamposDinamicos!= null){
          array = strCamposDinamicos.split("|##|").map(item => item.trim());
          setFields(array); 
          handleInput("campos_adicionales",true);
          
        }else{
          handleInput("campos_adicionales",false);
          setFields(array); 
        }       

      }
      
    });

  }

  function cleanForm() {
    setFormValues(() => {
      return Object.keys(formValues).reduce((result, item) => {
        return { ...result, [item]: "" };
      }, {});
    });
  }
  
const textoNotificacion = (formValues.notificacion || "").trim().replace(/[.\s]+$/, "");

const avisoNotificacion = textoNotificacion && (
  <div className="aviso-notificacion" role="alert">
    <span className="aviso-icono" aria-hidden="true">⚠️</span>
    <div className="aviso-texto">
      <strong>Aviso importante</strong>
      <p>
        {textoNotificacion}. 
        <br />
        Si deseas continuar con el proceso, diligencia los siguientes campos:
      </p>
    </div>
  </div>
);

  return (
    <Contenedor>
    <Body className="home">
      <Banner src={image} />
      <div ref={textBody}>
          <Paragraph className = "inicio">
          Estás en contacto con el área de soporte de MAAS App y queremos ayudarte 🤝 Para brindarte una atención más ágil y efectiva, te invitamos a llenar el siguiente formulario. Completa los campos y nosotros nos encargamos del resto. ¡Estamos para ti!
          </Paragraph>
          <br />
          <form
            id="mainForm"
            className="forms"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            style={{ marginLeft: "auto",
                    marginRight: "auto" 
                  }}
          >
            <div className="col-md-12">
              {/* Si NO viene "servicio" en el URL → mostrar select de servicio*/}
            {!formValues.mostrarIdentificacion && (
              <div
                onChange={(e) => {
                  const servicioSeleccionado = e.target.value;
                  handleInput("servicio", servicioSeleccionado);
                  handleInput("mostrarIdentificacion", true);
                  handleInput("servicioBloqueado", true); // ← bloquear después de seleccionar
                }}
              >
                <Input
                  name="servicio"
                  required={true}
                  value={formValues.servicio}
                  setValue={handleInput}
                  label="Selecciona el servicio"
                  type="select"
                  disabled={formValues.servicioBloqueado}   // ← bloquear si aplica
                  readOnly={formValues.servicioBloqueado}
                >
                  <option value="">Seleccione un servicio</option>
                  <option value="TAXI">TAXI</option>
                  <option value="TULLAVE">TULLAVE</option> 
                  <option value="PARKING">PARKING</option>
                </Input>
              </div>
            )}
            {formValues.servicioBloqueado && (
              <Input
                name="servicio"
                value={formValues.servicio}
                setValue={handleInput}
                label="Servicio seleccionado"
                type="text"
                readOnly={true}
              />
            )}
            {/* Si SÍ viene "servicio" → mostrar documento + email */}
            {formValues.mostrarIdentificacion && (
        <>
          <div
            className="cell"
            onChange={(e) => {
              e.preventDefault();
              setNumeroDoc(e.target.value);
              handleInput("numeroDoc", e.target.value);

              if (e.target.value.length > 16) {
                setNumeroDoc(e.target.value.substring(0, 16));
                handleInput("numeroDoc", e.target.value.substring(0, 16));
              }
            }}
          >
            <Input
              name="numeroDoc"
              required={true}
              value={formValues.numeroDoc}
              setValue={handleInput}
              label="Cédula"
              type="number"
              readOnly={formValues.soloLectura_Encabezado}
            />
          </div>

          <Input
            name="email"
            required={true}
            value={formValues.email}
            setValue={handleInput}
            label="Correo electrónico registrado en la app"
            type="email"
            readOnly={formValues.soloLectura_Encabezado}
          />

          {/* Botón Consultar solo si aplica */}
          {formValues.boton_siguiente_visible && (
            <button
              style={{ marginLeft: "0" }}
              onClick={(e) => {
                e.preventDefault();
                nextButton();
              }}
              className="btn2"
            >
              Consultar
            </button>
          )}
        </>
      )}
             <div className="col-md-12" >
                             
                {formValues.visualizar_existente && (
                  <div>
                    <br />
                    <hr className="separador" />
                    <Paragraph className="inicio">
                      ¡Hola, {formValues.nombre}! 👋
                    </Paragraph>
                    {avisoNotificacion || (
                      <Paragraph className="inicio">
                        Por favor completa estos datos para que podamos darte respuesta:
                      </Paragraph>
                    )}
                  </div>
                )}
                {formValues.visualizar_nuevo && (
                  <div>
                    <br />
                    <hr className="separador" />
                    <Paragraph className="inicio">
                      Hola, no estás registrado, pero puedes llenar los datos y dejarnos tu solicitud.
                    </Paragraph>
                    {avisoNotificacion}
                  </div>
                )}
                {formValues.visualizar_saludo && (
                    
                    <div className="col-md-12">
                    <div className="col-md-12" >
                        
                    {formValues.visualizar_fecha_nacimiento && 
                        <Input
                        name="fechaNacimiento"
                        required={true}
                        value={formValues.fechaNacimiento}
                        setValue={handleInput}
                        label="Fecha de nacimiento"
                        type="date"
                      ></Input>}

                        
                        {formValues.visualizar_campos && (                        
                            <div className="cell" onChange={e => setTipoIdDocumento(e.target.value)}>
                              <Input
                                      name="tipoIdDocumento"
                                      required={true}
                                      value={formValues.tipoIdDocumento}
                                      setValue={handleInput}
                                      label="Tipo de documento"
                                      readOnly={formValues.soloLectura}
                                      type="select"
                                    >
                                      <option value="">Seleccione un Tipo</option>
                                      <option value="CC">CC</option>
                                      <option value="CE">CE</option>
                                      <option value="TI">TI</option>
                                      <option value="PPT">PPT</option>
                                      <option value="PSP">PSP</option>
                                      <option value="NIT">NIT</option>
                          </Input>
                          
                                <Input
                                name="nombre"
                                required={true}
                                value={formValues.nombre}
                                setValue={handleInput}
                                label="Nombres"
                                type="text"
                                readOnly={formValues.soloLectura}
                              ></Input>
                            
                            <Input
                              name="apellido"
                              required={true}
                              value={formValues.apellido}
                              setValue={handleInput}
                              label="Apellidos"
                              type="text"
                              readOnly={formValues.soloLectura}
                            ></Input>
                           
                            <div className="cell" onChange={(e) => {
                                 //console.log("Onchange Tarjeta", e.target.value.length );
                                  e.preventDefault();
                                  setCelular(e.target.value);
                                  handleInput("celular",e.target.value);
                                  if (e.target.value.length > 10){
                                    //window.alert("El asunto debe tener maximo 50 caractares");
                                    setCelular(e.target.value.substring(0,10));
                                    handleInput("celular",e.target.value.substring(0,10));
                                  }
                                   }}>
                                  <Input
                                    name="celular"
                                    required={true}
                                    value={formValues.celular}
                                    setValue={handleInput}
                                    label="Celular"
                                    type="number"
                                    readOnly={formValues.soloLectura}
                                  ></Input>
                            </div>
                        </div> )}
                        
                        <br />
                        <br />
                        {config && (
                          <div
                            className="cell"
                            onChange={(e) => {
                              e.preventDefault();

                              let valor = e.target.value;

                              // Limitar longitud dinámicamente
                              if (valor.length > config.longitud) {
                                valor = valor.substring(0, config.longitud);
                              }

                              setNumTarjeta(valor);
                              handleInput("numeroTarjeta", valor);
                            }}
                          >
                            <Input
                              name="numero_tarjeta"
                              required={config.obligatorio}
                              value={numeroTarjeta}
                              setValue={handleInput}
                              label={config.label}
                              type={config.tipo}          // ← text o number
                              maxLength={config.longitud} // ← por si tu Input lo soporta
                            />
                          </div>
                        )}
                 
                        <div className="cell" onChange={(e) => {
                          console.log("Onchange tipoPQR", e.target.value);
                          e.preventDefault();
                          getPreguntas(e.target.value);
                        }}>
                          <Input
                            name="tipoPQR"
                            required={true}
                            value={formValues.tipoPQR}
                            setValue={handleInput}
                            label="Elige una opción para clasificar tu solicitud"
                            type="select"
                          >
                            <option value="">Seleccione un Tipo</option>
                            <option value="INFORMACIÓN">INFORMACIÓN</option>
                            <option value="RECLAMO">RECLAMO</option>
                            <option value="SOLICITUD">SOLICITUD</option>
                            <option value="SUGERENCIA">SUGERENCIA</option>
                            <option value="FELICITACIÓN">FELICITACIÓN</option>
                          </Input>


                        </div>
                        
                    </div>
                   
                    
                    <div className="cell" onChange={(e) => {
                      //console.log("Onchange Pregunta", e.target.value);
                      e.preventDefault();
                      validatePreguntaInfo(e.target.value);
                    }}>
                        <Input
                            name="preguntas"
                            required={true}
                            value={formValues.preguntas}
                            setValue={handleInput}
                            label="¿Qué necesitas resolver?"
                            type="select"
                          >
                            <option value="">Seleccione una pregunta</option>
                            {Array.isArray(preguntasXTipo) &&
                              preguntasXTipo.map((pregunta) => (
                                <option
                                  key={pregunta.value}
                                  value={pregunta.value}
                                >
                                  {pregunta.label}
                                </option>
                              ))}
                          </Input>
                          
                        
                      </div>
                      {formValues.descripcion_visible &&
                          <div className="cell" onChange={(e) => {
                            //console.log("Onchange Pregunta", e.target.value);
                            e.preventDefault();
                            handleInput("descripcion",e.target.value);
                          }}>
                            <Input
                                    id ="descripcion"
                                    name="descripcion"
                                    required={true}
                                    value={formValues.descripcion}
                                    setValue={handleInput}
                                    label="Descripción"
                                    type="textarea"
                                    readOnly={formValues.soloLectura}
                              ></Input>
                          </div>
                      }
                      
                    
                    
                    {formValues.archivos_visible && 
                        <div>
                          <br />
                          <label htmlFor="fileInput">{label_archivo}* : </label>
                        </div>
                    }
                    
                    {formValues.archivos_visible && 
                    <div> 
                       <br />
                      <input type="file" 
                          id="fileInput"
                          required 
                          onChange={(e) => {
                                setState({ selectedFile: e.target.files[0] });
                                //console.log("state", e.target.files[0]);
                                if (!e.target.files[0]) {
                                  setError(true);
                                  setMessage2("Debes seleccionar un archivo.");
                                  handleInput("habeasdata_visible", false);
                                  return;
                                }
                                if (e.target.files[0].size>10000000){
                                  console.log("Tamano Superado", e.target.files[0].size);
                                  setError(true);
                                  setMessage2("El archivo no puede superar los 10MB");
                                  handleInput("habeasdata_visible",false);
                                }else{
                                  console.log("Tamano OK", e.target.files[0].size);
                                  setMessage2("");
                                  handleInput("habeasdata_visible",true);
                                }
                                
                              }} />
                    </div>  
                    }
                    
                    <hr className="separador"/>
                    {formValues.campos_adicionales &&  
                          <div> 
                              <br />
                              <Paragraph className = "inicio">
                                  Por favor, ingresa estos datos adicionales:
                                  
                              </Paragraph>
                          </div> }
                    {fields.includes("cf_cases_fechayhoradelacompra")  && 
                        <Input
                            name="fechaHoraCompra"
                            required={true}
                            value={formValues.fechaHoraCompra}
                            setValue={handleInput}
                            label="Fecha y hora de la compra"
                            type="datetime-local"
                        ></Input>
                    }
                    {fields.includes("cf_cases_valordelacompra")  && 
                        <Input
                            name="valorCompra"
                            required={true}
                            value={formValues.valorCompra}
                            setValue={handleInput}
                            label="Valor de la compra"
                            type="currency"
                        ></Input>
                    }
                    {fields.includes("cf_cases_codigocus")  && 
                        <Input 
                          name="codigoCUS" 
                          required={true} 
                          value={formValues.codigoCUS} 
                          setValue={handleInput} 
                          label="CUS o ID de Transacción" 
                          infoText="Este código es único y lo proporciona la plataforma de pago al finalizar la transacción."
                          type="text" >                       
                        </Input>
                    }                                        
                    {fields.includes("cf_cases_versiondelaapp")  && 
                        <Input
                            name="versionApp"
                            required={true}
                            value={formValues.versionApp}
                            setValue={handleInput}
                            label="Version de la APP"
                            type="text"
                        ></Input>
                    }
                    {fields.includes("cf_cases_userid")  && 
                        <Input
                            name="userid"
                            required={true}
                            value={formValues.userid}
                            setValue={handleInput}
                            label="User ID"
                            type="text"
                        ></Input>
                    }
                    {fields.includes("cf_cases_correonuevo")  && 
                        <Input
                            name="correonuevo"
                            required={true}
                            value={formValues.correonuevo}
                            setValue={handleInput}
                            label="Correo nuevo"
                            type="text"
                        ></Input>
                    }
                    {fields.includes("cf_cases_celularnuevo")  && 
                        <div className="cell" onChange={(e) => {
                          //console.log("Onchange Tarjeta", e.target.value.length );
                          e.preventDefault();
                          setCelularNuevo(e.target.value);
                          handleInput("celularnuevo",e.target.value);
                          if (e.target.value.length > 10){
                            //window.alert("El asunto debe tener maximo 50 caractares");
                            setCelularNuevo(e.target.value.substring(0,10));
                            handleInput("celularnuevo",e.target.value.substring(0,10));
                          }
                            }}>
                        <Input
                            name="celularnuevo"
                            required={true}
                            value={formValues.celularnuevo}
                            setValue={handleInput}
                            label="Celular nuevo"
                            type="text"
                        ></Input>
                        </div>
                    }                   
                    {fields.includes("cf_cases_nombreempresaaliado")  && 
                        <Input
                            name="nombreempresaaliado"
                            required={true}
                            value={formValues.nombreempresaaliado}
                            setValue={handleInput}
                            label="Nombre empresa aiiada"
                            type="text"
                        ></Input>
                    }
                    {fields.includes("cf_cases_plataformadepago")  && 
                        <Input
                            name="plataformadepago"
                            required={true}
                            value={formValues.plataformadepago}
                            setValue={handleInput}
                            label="Plataforma de pago"
                            type="select"
                          >
                              <option value="">Seleccione un Tipo</option>
                              <option value="AVANZO">AVANZO</option>                             
                              <option value="BOTÓN NEQUI DENTRO DE LA APP">BOTÓN NEQUI DENTRO DE LA APP</option>
                              <option value="BOTÓN PSE DENTRO DE LA APP">BOTÓN PSE DENTRO DE LA APP</option>
                              <option value="CLARO">CLARO</option> 
                              <option value="DAVIPLATA">DAVIPLATA</option>                                           
                              <option value="TARJETA CRÉDITO">TARJETA CRÉDITO</option>
                              <option value="TARJETA DÉBITO">TARJETA DÉBITO</option>
                              <option value="ADELANTA TU PAGO">ADELANTA TU PAGO</option>
                              <option value="APP NEQUI">APP NEQUI</option>
                              <option value="COMPENSAR">COMPENSAR</option>
                              <option value="T PAGA">T PAGA</option>
                              <option value="DALE">DALE</option>
                              <option value="QUANTUM">QUANTUM</option>   
                          </Input>
                    }
                    {fields.includes("cf_cases_funcionalidad")  && 
                        <Input
                            name="funcionalidad"
                            required={true}
                            value={formValues.funcionalidad}
                            setValue={handleInput}
                            label="Funcionalidad:"
                            type="select"
                          >
                              <option value="">Seleccione un Tipo</option>
                              <option value="Activaciones">Activaciones</option>
                              <option value="Métodos de pago">Métodos de pago</option>
                              <option value="Recuperar clave">Recuperar clave</option>
                              <option value="Registro">Registro</option>
                              <option value="Rutas">Rutas</option>
                              <option value="Tarjetas">Tarjetas</option>
                              <option value="TransMiPass">TransMiPass</option>
                          </Input>
                    }
                    {fields.includes("cf_cases_ubicacionorigen")  && 
                        <Input
                            name="ubicacionorigen"
                            required={true}
                            value={formValues.ubicacionorigen}
                            setValue={handleInput}
                            label="Ubicacion punto de origen"
                            type="text"
                        ></Input>
                    } 
                    {fields.includes("cf_cases_ubicacion")  && 
                        <Input
                            name="ubicacion"
                            required={true}
                            value={formValues.ubicacion}
                            setValue={handleInput}
                            label="Ubicacion"
                            type="text"
                        ></Input>
                    } 
                    {fields.includes("cf_cases_fechayhoradelevento")  && 
                        <Input
                            name="fechayhoradelevento"
                            required={true}
                            value={formValues.fechayhoradelevento}
                            setValue={handleInput}
                            label="Fecha y hora del evento"
                            type="datetime-local"
                        ></Input>
                    }
                    
                    <div>
                      {message && (
                        <Paragraph>
                          <center>
                            {message.split("\n").map((linea, index) => (
                              <span key={index} style={{ color: "red" }}>
                                {linea}
                                <br />
                              </span>
                            ))}
                          </center>
                        </Paragraph>
                      )}
                    </div>
                    {formValues.boton_visible &&
                    <button className="btn2" type="submit" style={{ marginLeft: "0" }}>
                    ENVIAR
                    </button>}
                </div>
                )}
                {message2 && (
                      <div className="resaltado">
                        <Paragraph>
                          <center>
                            <span className="inicio">{message2}</span>
                          </center>
                        </Paragraph>
                        <br />
                        <br />
                      </div>
                      
                    )}
                {formValues.habeasdata_visible && (
                    <div className="checkbox-container">
                      <input
                        type="checkbox"
                        id="habeasData"
                        checked={aceptado}
                        onChange={handleChange}
                      />
                      <label htmlFor="habeasData">
                        He leído y acepto la{" "}
                        <a href="https://www.maasapp.co/politica-de-tratamiento-de-datos" target="_blank" rel="noopener noreferrer">
                          política de tratamiento de datos personales
                        </a>
                      </label>
                      <br />
                    </div>
                )}
              </div>
              
              
            </div>
            
          </form>
      </div>
    
      
      

    </Body>
    </Contenedor>
  );
}

export default Home;
